const POINT = 2;
const LINESTRING = 3;
const POLYGON = 4;
const MULTI_POINT = 5;
const MULTI_LINESTRING = 6;
const MULTI_POLYGON = 7;

const NAMES = {
	['GEOMETRY']: 0,
	['POINT']: POINT,
	['LINESTRING']: LINESTRING,
	['POLYGON']: POLYGON,
	['MULTIPOINT']: MULTI_POINT,
	['MULTILINESTRING']: MULTI_LINESTRING,
	['MULTIPOLYGON']: MULTI_POLYGON,	
}

const getGeometryType = name => {
	const type = NAMES[name];
	if( !(name in NAMES) ) {
		console.log("Unknown geometry type ", name); 
	} 
	
	return type;
}

export {
	POINT,
	LINESTRING,
	POLYGON,
	MULTI_POINT,
	MULTI_LINESTRING,
	MULTI_POLYGON, 
	getGeometryType
}
